// brand constants
export const brand = process.env.REACT_APP_brand;    //aie, emendy, gdc, learnfast, cadco
export const AWS_File_URL = process.env.REACT_APP_AWS_File_URL;

export const LOCAL_HOST_DOMAIN = "student.myaie.ac"
export const WS_URL = process.env.REACT_APP_WS_URL;

//WHEN PUBLISHING:
//Change in package.json the "homepage" to the site page, ex https://www.mygdc.ac
export const APP_LINK = process.env.REACT_APP_APP_LINK;
export const API_BASE = process.env.REACT_APP_API_BASE;
export const STUDENT_FILE_DOWNLOAD = process.env.REACT_APP_STUDENT_FILE_DOWNLOAD;
export const STUDENT_FILE_URI = process.env.REACT_APP_STUDENT_FILE_URI;
export const DOWNLOAD_FILE_URI = process.env.REACT_APP_DOWNLOAD_FILE_URI;
export const showWhatsapp = process.env.REACT_APP_showWhatsapp === 'true';
export const marketingUrl = process.env.REACT_APP_MARKETING_SITE_URL;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const UPLOAD_ROOT_PATH = process.env.REACT_APP_UPLOAD_ROOT_PATH;
export const MOBILE_REGEX = /^(\+|\d)[0-9]{7,16}$/;
export const EMAIL_REGEX = /^(?!www\.)(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})(?<!\.co)$/;
//global variable
export const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD;
export const TABLE_ROWS_PER_PAGE = [10, 15, 20, 25, 30, 50, 100];
//Style URLs
export const STYLE_URL_AIE = "student.myaie.ac";
export const STYLE_URL_GDC = "mygdc.ac";
export const STYLE_URL_LOCALHOST_3000 = "localhost:3000";
export const STYLE_URL_LOCALHOST_3001 = "localhost:3001";


//zip download url hack
export const zipURL = process.env.REACT_APP_zipURL; 
export const DOMAIN_URL = process.env.REACT_APP_DOMAIN_URL;
export const DEFAULT_DATETIME = "0000-00-00 00:00:00";

// design token urls
export const DESIGN_TOKENS_URL = "https://myaie.ac/tokens/tokens.json";
export const CSS_OUTPUT_FILE = "src/public/tokens.css";
export const JS_OUTPUT_FILE = "src/public/tokens.js";

export const LANGUAGES = [
    {
        "value": "Afrikaans",
        "label": "Afrikaans"
    },
    {
        "value": "English",
        "label": "English"
    },
    {
        "value": "Ndebele",
        "label": "Ndebele"
    },
    {
        "value": "Nothern Sotho",
        "label": "Nothern Sotho"
    },
    {
        "value": "Other",
        "label": "Other"
    },
    {
        "value": "Southern Sotho",
        "label": "Southern Sotho"
    },
    {
        "value": "Swati",
        "label": "Swati"
    },
    {
        "value": "Tsonga",
        "label": "Tsonga"
    },
    {
        "value": "Tswana",
        "label": "Tswana"
    },
    {
        "value": "Venda",
        "label": "Venda"
    },
    {
        "value": "Xhosa",
        "label": "Xhosa"
    },
    {
        "value": "Zulu",
        "label": "Zulu"
    }
]